export const CircleStarted = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    aria-hidden="true"
    focusable="false"
  >
    <circle
      cx="12.5898"
      cy="12.4116"
      r="6.81494"
      stroke="#004597"
      strokeWidth="1.5"
    />
  </svg>
);
